// @flow

import {
  type UserInputValidationError,
  type UserInputValidatorArgs,
  onlyWhenSupport,
  VALID,
} from '@tectonics/prs/validation';

import { validateEcuadorianAddress } from './ecuadorian-address';
import { validateEcuadorianDocument } from './ecuadorian-document';
import { validateEcuadorianPhoneNumber } from './ecuadorian-phone-number';

import { getCurrentFeatures } from '@tectonics/prs/payment-spec';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);

  switch (userInputName) {
    case 'ecuadorianDocument':
      return onlyWhen('field_ecuadorian_document') && validateEcuadorianDocument(userInputValue);

    case 'ecuadorianPhoneNumber':
      return onlyWhen('field_ecuadorian_phone_number') && validateEcuadorianPhoneNumber(userInputValue);

    case 'ecuadorianAddress':
      return onlyWhen('field_ecuadorian_address') && validateEcuadorianAddress(userInputValue);

    default:
      return VALID;
  }
}
